<app-page-header subtitle="Verlof"> </app-page-header>
<div class="container">
    <div class="row align-items-center mb-3">
        <div class="col-auto">
            <mat-checkbox [formControl]="fcShowHistoric">Toon historie</mat-checkbox>
        </div>
        <div class="col">
            <ng-select
                [formControl]="fcUsers"
                [items]="users"
                [multiple]="true"
                [clearable]="true"
                bindLabel="name"
                bindValue="id"
                placeholder="Filter op medewerkers">
            </ng-select>
        </div>
    </div>
    <table class="table table-hover" [class.table-last-col]="Features.LeaveDetailDelete | hasFeature">
        <thead>
            <tr>
                <th>Soort</th>
                <th>Opmerking</th>
                <th>Medewerkers</th>
                <th width="310">Periode</th>
                @if (Features.LeaveDetailDelete | hasFeature) {
                    <th></th>
                }
            </tr>
        </thead>
        <tbody>
            @for (leave of filteredLeaves; track leave) {
                <tr
                    class="curpoint"
                    [class.past]="leave.enddate | datetimeBefore: now"
                    [class.current]="(leave.begindate | datetimeBefore: now) && !(leave.enddate | datetimeBefore: now)"
                    (click)="edit(leave)">
                    <td width="160">
                        {{ leave.hourtype | hourtype }}
                    </td>
                    <td>
                        {{ leave.comment }}
                    </td>
                    @if (!leave.common) {
                        <td>
                            @for (user of leave.users; track user; let last = $last) {
                                {{ user.name }}{{ last ? '' : ', ' }}
                            }
                        </td>
                    } @else if (leave.common) {
                        <td>Bedrijfsbreed</td>
                    }
                    <td>
                        <div class="d-flex justify-content-between">
                            <div>
                                {{ leave.begindate | date: 'EEE d MMM yyyy' }}
                            </div>
                            @if (leave.begindate | isOtherDate: leave.enddate) {
                                <div>t/m</div>
                                <div>
                                    {{ leave.enddate | date: 'EEE d MMM yyyy' }}
                                </div>
                            }
                        </div>
                        <small class="d-flex justify-content-between color-black">
                            @if (leave.interval_week > 0) {
                                <div>
                                    {{ leave | leaveRepeatDays }}
                                    @if (!leave.close_period && !leave.close_day) {
                                        {{ leave.begintime | slice: 0 : 5 }} -
                                        {{ leave.endtime | slice: 0 : 5 }}
                                    }
                                </div>
                            }
                            @if (leave.close_period || leave.close_day) {
                                <div>
                                    {{ leave.close_period ? 'Periode dichtgezet' : 'Hele dag' }}
                                    <i class="ms-2 fal fa-lock"></i>
                                </div>
                            }
                        </small>
                    </td>
                    @if (Features.LeaveDetailDelete | hasFeature) {
                        <td>
                            <button (click)="delete($event, leave)" color="warn" mat-icon-button>
                                <mat-icon class="fas fa-trash"></mat-icon>
                            </button>
                        </td>
                    }
                </tr>
            } @empty {
                <tr>
                    <td class="text-center" colspan="100%">Geen verlof gevonden</td>
                </tr>
            }
        </tbody>
    </table>
</div>
@if (Features.LeaveSave | hasFeature) {
    <div class="button-wrapper">
        <div class="container-xl">
            <div class="buttons">
                <button (click)="edit()" mat-raised-button color="primary">Verlof toevoegen</button>
            </div>
        </div>
    </div>
}
